import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, BlankSlate as GammaBlankSlate } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const BlankSlate = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const onOpenImport = () => navigate(navigation.employees.list.import.fullPath())

  return (
    <GammaBlankSlate
      illustration="add-user"
      title={i18n.t('common.employees')}
      description={i18n.t('employees.blank_slate')}
    >
      <Box paddingY="s16">
        <Button.Router to={navigation.employees.list.add_employee.fullPath()}>
          {i18n.t('employees.add_first_employee')}
        </Button.Router>
      </Box>
      {i18n.t('common.or')}
      <Box paddingY="s16">
        <Button onClick={onOpenImport}>{i18n.t('common.import')}</Button>
      </Box>
    </GammaBlankSlate>
  )
}

export default BlankSlate
